import { z } from "zod";

export const oneClickAutomationSchema = z.object({
  categoryId: z.string().optional(),
  groups: z.array(z.string()),
});

export type OneClickAutomationFormValues = z.infer<typeof oneClickAutomationSchema>;
